import {Pipe, PipeTransform} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';

@Pipe({
    name: 'filterDetailLineBySite'
})
export class FilterDetailLineBySitePipe implements PipeTransform {

    transform(detailLines: DetaillineDTOModel[], siteAndLive: any): DetaillineDTOModel[] {

        if (!detailLines) {
            return detailLines;
        }

        if (siteAndLive[1] === 'live') {
            return detailLines.filter(line => line.site === siteAndLive[0] && line.stat === 200);
        }

        if (siteAndLive[1] === 'collection') {
            return detailLines.filter(line => line.site === siteAndLive[0] && line.stat !== 200);
        }
    }

}
